import Table, { tableProps } from './Table';
import Column from './Column';
import ColumnGroup from './ColumnGroup';
import { defineComponent } from 'vue';
import { Summary, SummaryCell, SummaryRow } from '../vc-table';
import { SELECTION_ALL, SELECTION_INVERT, SELECTION_NONE } from './hooks/useSelection';
const TableSummaryRow = defineComponent(Object.assign(Object.assign({}, SummaryRow), { name: 'ATableSummaryRow' }));
const TableSummaryCell = defineComponent(Object.assign(Object.assign({}, SummaryCell), { name: 'ATableSummaryCell' }));
const TempSummary = defineComponent(Object.assign(Object.assign({}, Summary), { name: 'ATableSummary' }));
const TableSummary = TempSummary;
TableSummary.Cell = TableSummaryCell;
TableSummary.Row = TableSummaryRow;
const T = Table;
T.SELECTION_ALL = SELECTION_ALL;
T.SELECTION_INVERT = SELECTION_INVERT;
T.SELECTION_NONE = SELECTION_NONE;
T.Column = Column;
T.ColumnGroup = ColumnGroup;
T.Summary = TableSummary;
/* istanbul ignore next */
T.install = function (app) {
    app.component(TableSummary.name, TableSummary);
    app.component(TableSummaryCell.name, TableSummaryCell);
    app.component(TableSummaryRow.name, TableSummaryRow);
    app.component(T.name, T);
    app.component(T.Column.name, Column);
    app.component(T.ColumnGroup.name, ColumnGroup);
    return app;
};
export { tableProps, TableSummary, TableSummaryRow, TableSummaryCell, Column as TableColumn, ColumnGroup as TableColumnGroup, };
export default T;
